@if(!isVizModule) {
	<div>
		<nav class="breadcrumb mt-2 mb-0 font-content-breadcrumb">
			<span class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs" >{{breadcrumb.description | translate}}</span>
		</nav>
	</div>
} @else {
	<div>
		<nav class="breadcrumb mt-2 mb-0 font-content-breadcrumb">
			<span class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs" >
				@if(needVizPrefix(breadcrumb)) {
					<span class="viz-font-content-breadcrumb">{{ 'VIZ.VIZ' | translate}}</span>
				}
				{{breadcrumb.description | translate}}
			</span>
		</nav>
	</div>
}
